import { createReducer } from "@reduxjs/toolkit";

import {
  resetFileUploadProgressActionTypes,
  setFileUploadProgressActionTypes,
  uploadMultipartFailureActionTypes,
} from "./actionTypes";
import { uploadFile, uploadFileSuccess } from "./actions";

// todo: handle all user posts for feed

/**
 * @property {number[]} allPosts array of post ids
 * @property {object[]} postsById { [postId]: {postContent} }
 */
const initialState = {
  filesUploadProgress: [],
  files: {},
  error: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(setFileUploadProgressActionTypes, (state, action) => {
      return {
        ...state,
        filesUploadProgress: action.payload,
      };
    })
    .addCase(resetFileUploadProgressActionTypes, () => {
      return initialState;
    })
    .addCase(uploadMultipartFailureActionTypes, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    })
    .addCase(uploadFile.type, (state) => {
      return {
        ...state,
        files: {
          ...state.files,
        },
      };
    })
    .addCase(uploadFileSuccess.type, (state) => {
      return {
        ...state,
        files: {
          ...state.files,
        },
      };
    });
});
